export default "__VITE_ASSET__CyzvpBiB__"